import { Box, Button, Divider, Grid, List, ListItem, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SnackbarAlert } from "../../common/SnackbarAlert";

export const Summary = ({ quote, handleResidentialTab, type }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);

  const serviceType = type || (quote?.serviceQuote ? "residential" : "commercial");

  const services = serviceType === "residential" ? [quote?.serviceQuote] : quote?.serviceQuotes || [];

  const DataList = ({ title, data }) => {
    const isEmptyObject = !data || typeof data !== "object" || Object.keys(data).length === 0;


    return (
      <Box>
        <Typography sx={{ fontSize: 14, textTransform: "capitalize", mb: 1 }}>{title}</Typography>
        <Divider />
        {isEmptyObject && <Typography>N/A</Typography>}
        <List sx={{ zIndex: 999999999, py: 0.5 }}>
          {Object.entries(data).map(([key, value]) => {
            if (Array.isArray(value)) {
              return (
                <ListItem key={key} sx={{ zIndex: 999999999, py: 0.5 }}>
                  <Typography sx={{ fontSize: 14 }}>{key}:</Typography>
                  <Box sx={{ ml: 1 }}>
                    <SuppliesHover items={value} />
                  </Box>
                </ListItem>
              );
            }

            return (
              <ListItem key={key} sx={{ py: 0.5 }}>
                <Typography sx={{ fontSize: 14 }}>{key}:</Typography>
                <Typography sx={{ fontSize: 14, ml: 1 }}>{typeof value === "number" ? value.toFixed(2) : String(value)}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    );
  };

  const SuppliesHover = ({ items }) => (
    <Tooltip
      placement="right"
      arrow
      title={
        <Box>
          {items?.length > 0 ? (
            items.map((item) => (
              <Typography key={item.supplyId || item.id} sx={{ fontSize: 14, mb: 0.5 }}>
                • {item.name}
              </Typography>
            ))
          ) : (
            <Typography sx={{ fontSize: 14 }}>Not supplies selected</Typography>
          )}
        </Box>
      }
    >
      <Box
        sx={{
          zIndex: 99999999,
          bgcolor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.15)",
          m: 0.2,
          p: 0.5,
          borderRadius: 30,
        }}
      >
        <Typography variant="caption">View all</Typography>
      </Box>
    </Tooltip>
  );

  return (
    <Box sx={{ width: "100%", mb: 2, mt: 2 }}>
      <Button onClick={() => handleResidentialTab(0)}>
        <ArrowBackIcon />
      </Button>

      <Typography variant="h4" fontSize={18} fontWeight="bold" textAlign="center">
        Summary
      </Typography>

      <Grid container sx={{ xs: 2, md: 3, p: 2 }}>
        {/* Header section */}
        <Grid item xs={12} lg={8}>
          <Box sx={{ display: "grid", rowGap: 1, m: 3 }}>
            <Typography sx={{ textTransform: "capitalize", fontSize: 14 }}>
              <strong>Work Type:</strong> {serviceType}
            </Typography>
            <Typography sx={{ textTransform: "capitalize", fontSize: 14 }}>
              <strong>Services:</strong> {quote?.totalServicesCalc}
            </Typography>
          </Box>
        </Grid>

        {/* Services */}
        <Grid item xs={12} sx={{ ml: 3 }}>
          <Typography sx={{ fontWeight: "bold", fontSize: 18 }}>Services</Typography>

          {services.map((service, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: "bold", fontSize: 15 }}>{service?.service}</Typography>
              <Typography sx={{ fontSize: 14 }}>Square ft: {service?.squareFt}</Typography>

              <Box
                sx={{
                  display: "flex",
                  flexFlow: "row wrap",
                  alignContent: "flex-start",
                  gap: 4,
                  mt: 2,
                }}
              >
                {Object.entries(service)
                  .filter(([_, value]) => typeof value === "object" && value !== null && !Array.isArray(value))
                  .map(([sectionKey, sectionData]) => (
                    <DataList key={sectionKey} title={sectionKey} data={sectionData} />
                  ))}
              </Box>
            </Box>
          ))}
        </Grid>

        {/* Totals */}
        <Grid
          item
          sx={{
            ml: 3,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            mt: 2,
          }}
        >
          <Typography sx={{ fontSize: 14 }}>
            <strong>Total Cost Per SF:</strong> {quote?.grandCostPerSfCalc}
          </Typography>
          <Typography sx={{ fontSize: 14 }}>
            <strong>Total Cost Per Service:</strong> {quote?.grandServiceCostCalc}
          </Typography>
          <Typography sx={{ fontSize: 14 }}>
            <strong>Monthly Cost:</strong> {quote?.grandMonthtlyRateCalc}
          </Typography>
        </Grid>
      </Grid>

      <SnackbarAlert
        openState={error}
        setOpenState={setError}
        severity="error"
        duration={10000}
        message={`Sorry, we couldn't generate your quote. ${errorMessage}`}
      />
    </Box>
  );
};
